export default __webpack_public_path__ + "static/media/icn-exclamation.af17d8e0.svg";